<div tabindex="101" *ngIf="appError" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId"
  id="pageLevelMessageId" #pageMsg>
  <div class="ontario-columns">
    <div class="ontario-alert ontario-alert--error">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-error"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">
          {{ "bss.error" | translate }}
        </h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appErrorMessage | translate">
      </div>
    </div>
  </div>
</div>

<input type="hidden" name="menuType" id="menuType" value="secure" />
<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <h2 id="pageTitle">{{'bss.admin.resetPassword.title'| translate}}</h2>
    <hr>
  </div>
</div>

<div class="ontario-row">
  <div class="ontario-column ontario-small-12">

    <h4>{{'bss.admin.resetPassword.subTitle'| translate}}</h4>
    <p>{{'bss.admin.resetPassword.content.first'|
      translate}}{{this.user.email}}{{'bss.admin.resetPassword.content.second'|translate}}</p>


    <button tabindex="101" class="ontario-button ontario-button--primary" (click)="resetPassword(0)"
      title=" {{'bss.admin.resetPassword.button.title' | translate }}">
      {{'bss.admin.resetPassword.button' | translate }}

    </button>
    <button class="ontario-button ontario-button--secondary"
      title="{{'bss.admin.resetPassword.button.cancel.title' | translate}}" tabindex="102" (click)="onCancel()">
      {{'bss.admin.resetPassword.button.cancel' | translate}}
    </button>
  </div>
</div>

<div *ngIf="isMPRADMIN" class="ontario-row">
  <div class="ontario-column ontario-small-12">

    <h4>{{'bss.admin.resetPassword.MPR.title'| translate}}</h4>

    <p>{{'bss.admin.resetPassword.MPR.content.first'|
      translate}}{{this.user.email}}{{'bss.admin.resetPassword.MPR.content.second'| translate}}</p>
    <!-- <p>
      {{'bss.admin.resetPassword.MPR.content.checkbox.first'|translate}} {{this.user.email}}{{'bss.admin.resetPassword.MPR.content.checkbox.second'|translate}}
    </p> -->

    <!-- <div class="ontario-checkboxes">
      <div class="ontario-checkboxes__item">
        <input aria-describedby="agreeReqError" tabindex="103" class="ontario-checkboxes__input" id="agreeTerms"
          name="agreeTerms" type="checkbox" [(ngModel)]="checkboxValue"
          title="{{'bss.admin.resetPassword.checkbox.description' | translate }}" #checkbox>
        <label class="ontario-checkboxes__label" for="agreeTerms">
          {{'bss.admin.resetPassword.checkbox' | translate }}{{this.user.email}}
        </label>
      </div>

    </div> -->

    <button tabindex="104" class="ontario-button ontario-button--primary" (click)="resetPassword(1)"
      title=" {{'bss.admin.resetPassword.MPR.button.title' | translate }}">
      {{'bss.admin.resetPassword.MPR.button' | translate }}
    </button>
    <button class="ontario-button ontario-button--secondary"
      title="{{'bss.admin.resetPassword.button.cancel.title' | translate}}" tabindex="105" (click)="onCancel()">
      {{'bss.admin.resetPassword.button.cancel' | translate}}
    </button>
    <p>{{'bss.admin.resetPassword.redirect.first'|translate}} {{this.user.email}} {{'bss.admin.resetPassword.redirect.second'|translate}}
    <a tabindex="106" (click)="setAccess()" title="{{ 'bss.admin.resetPassword.redirect.click.title' | translate }}">
      {{'bss.admin.resetPassword.redirect.click' | translate }}
    </a></p>
  </div>


</div>
<dialog class="ontario-progress" #progressDialog>
  <app-progress></app-progress>
</dialog>